<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Vendor Config</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
    <form [formGroup]="vendorConfigForm">
        <div class="tab-content" id="v-pills-tabContent">
            <div class="tab-pane fade show active" id="v-pills-shipping" role="tabpanel"
                aria-labelledby="v-pills-shipping-tab">
                <div class="row">
                    <div class="col-md-12 grid-container">
                        <div class="table-responsive">
                            <table class="table table-bordered border-top ">
                                <thead class="table-dark">
                                    <tr>
                                        <th class="text-nowarp" style="width: 90%;">Description</th>
                                        <th class="text-nowarp" style="width: 10%;"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    
                                    <ng-container formArrayName="configDetails">
                                        <tr class="event-type"
                                            *ngFor="let detail of configDetails.controls;let i = index"
                                            [formGroupName]="i">
                                            <td class="text-nowarp" style="width: 90%;">
                                                <label><b>{{detail.get('title').value}}</b></label>
                                            </td>
                                            <td style="width: 10%;">
                                                <div class="form-check d-flex justify-content-center">
                                                    <input class="form-check-input" type="checkbox"
                                                        formControlName="ischecked">
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-container>
                                    
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="onSaveClick()" (keydown.enter)="onSaveClick()">Save</button>
</div>